import { useMemo } from 'react';
import { useDocument } from '@nandorojo/swr-firestore';
import { SettingCollectionPath } from '@typings/collections.enum';
import {
  IQuestBoardSetting,
  getQuestLabel,
  getQuestTypeLabel,
} from '@typings/quest/questTypes';

/**
 * 퀘스트 게시판 설정 훅
 * - SWR 캐시로 동일 구독 재사용 → prop drilling 불필요
 * - 관리자 설정 페이지에서는 사용하지 않음 (커스텀 용어 미적용)
 */
export function useQuestBoardSetting() {
  const { data } = useDocument<any>(SettingCollectionPath.QUEST, {
    listen: true,
  });

  return useMemo(() => {
    const setting: IQuestBoardSetting | undefined = data ?? undefined;
    const isTimelineIntegrated = setting?.timelineIntegration?.enabled ?? false;
    return {
      questBoardSetting: setting,
      questLabel: getQuestLabel(setting),
      getQuestTypeLabel: (type: Parameters<typeof getQuestTypeLabel>[0]) =>
        getQuestTypeLabel(type, setting),
      isTimelineIntegrated,
      timelineBoardPath:
        setting?.timelineIntegration?.timelineBoardPath || 'timeline',
      /** 타임라인 게시글을 LOG_COUNT 집계 소스로 사용 (Phase 2) */
      logCountFromTimeline:
        isTimelineIntegrated &&
        (setting?.timelineIntegration?.logCountFromTimeline ?? false),
    };
  }, [data]);
}
